/**
 * External Dependencies
 */
import { get } from 'lodash';

export default (state, userId) => {
    return get(state, ['users', 'items', userId], null);
};
